import React, { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [mode, setMode] = useState('login') // 'login' | 'reset'
  const [resetSent, setResetSent] = useState(false)

  async function handleLogin(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError(error.message)
    setLoading(false)
  }

  async function handleReset(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin
    })
    if (error) setError(error.message)
    else setResetSent(true)
    setLoading(false)
  }

  const inp = {
    width: '100%', padding: '10px 12px', border: '1px solid #ddd',
    borderRadius: 6, fontSize: 14, fontFamily: 'inherit', outline: 'none',
    marginTop: 4
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#f5f5f3', padding: 24
    }}>
      <div style={{
        background: '#fff', borderRadius: 12, padding: '40px 36px',
        width: '100%', maxWidth: 380, boxShadow: '0 2px 16px rgba(0,0,0,0.08)'
      }}>
        <div style={{ marginBottom: 28, textAlign: 'center' }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2, color: '#999', textTransform: 'uppercase', marginBottom: 6 }}>
            Cimon Starr LLC
          </div>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a1a' }}>Procurement</h1>
        </div>

        {mode === 'login' ? (
          <form onSubmit={handleLogin}>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 11, fontWeight: 600, color: '#555', letterSpacing: 0.3 }}>Email</label>
              <input style={inp} type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ fontSize: 11, fontWeight: 600, color: '#555', letterSpacing: 0.3 }}>Password</label>
              <input style={inp} type="password" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            {error && <div style={{ color: '#c0392b', fontSize: 13, marginBottom: 14 }}>{error}</div>}
            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '10px', background: '#1a1a1a', color: '#fff',
              border: 'none', borderRadius: 6, fontSize: 14, fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.6 : 1
            }}>
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
            <button type="button" onClick={() => setMode('reset')} style={{
              width: '100%', marginTop: 10, padding: '8px', background: 'none',
              border: 'none', color: '#888', fontSize: 12, cursor: 'pointer'
            }}>
              Forgot password?
            </button>
          </form>
        ) : (
          <form onSubmit={handleReset}>
            {resetSent ? (
              <div style={{ textAlign: 'center', color: '#2e7d32', fontSize: 14, lineHeight: 1.6 }}>
                ✓ Check your email for a password reset link.
                <br />
                <button type="button" onClick={() => { setMode('login'); setResetSent(false); }} style={{
                  marginTop: 14, background: 'none', border: 'none', color: '#888', fontSize: 12, cursor: 'pointer'
                }}>Back to sign in</button>
              </div>
            ) : (
              <>
                <p style={{ fontSize: 13, color: '#666', marginBottom: 16, lineHeight: 1.6 }}>
                  Enter your email and we'll send you a reset link.
                </p>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ fontSize: 11, fontWeight: 600, color: '#555', letterSpacing: 0.3 }}>Email</label>
                  <input style={inp} type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
                </div>
                {error && <div style={{ color: '#c0392b', fontSize: 13, marginBottom: 14 }}>{error}</div>}
                <button type="submit" disabled={loading} style={{
                  width: '100%', padding: '10px', background: '#1a1a1a', color: '#fff',
                  border: 'none', borderRadius: 6, fontSize: 14, fontWeight: 600,
                  cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.6 : 1
                }}>
                  {loading ? 'Sending…' : 'Send Reset Link'}
                </button>
                <button type="button" onClick={() => setMode('login')} style={{
                  width: '100%', marginTop: 10, padding: '8px', background: 'none',
                  border: 'none', color: '#888', fontSize: 12, cursor: 'pointer'
                }}>
                  Back to sign in
                </button>
              </>
            )}
          </form>
        )}
      </div>
    </div>
  )
}
